import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/common/Login'

//管理员-公共
import Member from '@/components/admin/Member'
import OnlineRecord from '@/components/admin/OnlineRecord'

//管理员-货代
import AdminHome from '@/components/admin/logistics/HomePage'
import MemberRechargeLog from '@/components/admin/logistics/MemberRechargeLog'
import MemberOrder from '@/components/admin/logistics/Order'
import Print from '@/components/admin/logistics/Print'
import OrderStatistics from '@/components/admin/logistics/OrderStatistics'
import PackingStatistics from '@/components/admin/logistics/PackingStatistics'
import AminShop from '@/components/admin/logistics/Shop'

//管理员-上架
import AdminProHome from '@/components/admin/product/ProHomePage'
import Package from '@/components/admin/product/Package'
import PackageSet from '@/components/admin/product/PackageSet'
import PackageLog from '@/components/admin/product/PackageLog'
import ProductWithdraw from '@/components/admin/product/Withdraw'
import AdminCol from '@/components/admin/product/Col.vue'
import AdminProduct from '@/components/admin/product/Product'
import AdminGlobal from '@/components/admin/product/Global'
import DetailGlobal from '@/components/admin/product/DetailGlobal'
import Detail from '@/components/admin/product/Detail'

//管理员-金融
import AdminFinHome from '@/components/admin/finance/HomePage'
import UserList from '@/components/admin/finance/UserList'
import Invest from '@/components/admin/finance/Invest'
import FinOrder from '@/components/admin/finance/Order'
import Raise from '@/components/admin/finance/Raise'
import Withdraw from '@/components/admin/finance/Withdraw'

//货代
import DeHome from '@/components/deliveryman/HomePage'
// import DeOrder from '@/components/deliveryman/Order'
import DeOrder from '@/components/admin/logistics/Order'
import LogList from '@/components/deliveryman/LogList'
import DePackingStatistics from '@/components/deliveryman/PackingStatistics'

//用户-货代
import UserHomePage from '@/components/logistics/HomePage'
import Shop from '@/components/logistics/Shop'
import Order from '@/components/logistics/Order'
import Recharge from '@/components/logistics/Recharge'
import RechargeRecord from '@/components/logistics/RechargeRecord'
import ConsumptionRecord from '@/components/logistics/ConsumptionRecord'
import Promote from '@/components/logistics/Promote'
import Return from '@/components/logistics/Return'
import Stock from '@/components/logistics/Stock'
import StockRecord from '@/components/logistics/StockRecord'
import PackageExamine from '@/components/logistics/PackageExamine'
import ProductLog from '@/components/logistics/Product'

//用户-上架
import HomePage from '@/components/product/HomePage'
import Col from '@/components/product/Col'
import Product from '@/components/product/Product'
import Global from '@/components/product/Global'
import Edit from '@/components/product/Edit'
import Shops from '@/components/product/Shop'
import EditGlobal from '@/components/product/EditGlobal'
import Pricing from '@/components/product/Pricing'
import Bulk from '@/components/product/Bulk'
import BulkGlobal from '@/components/product/BulkGlobal'
import Servicelimit from '@/components/product/Servicelimit'
import Purchased from '@/components/product/Purchased'
import Space from '@/components/product/Space'
import ProductPromote from '@/components/product/Promote'
import RebateRecord from '@/components/product/RebateRecord'
import BalanceManage from '@/components/product/BalanceManage'

//用户-管理
import OrderManage from '@/components/manage/Order'
import ShopManage from '@/components/manage/Shop'
import ProductManage from '@/components/manage/Product'
import ManageHomePage from '@/components/manage/HomePage'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },{
      path: '/UserHomePage',
      name: 'UserHomePage',
      component: UserHomePage
    },{
      path: '/Shop',
      name: 'Shop',
      component: Shop
    },{
      path: '/Order',
      name: 'Order',
      component: Order
    },{
      path: '/Recharge',
      name: 'Recharge',
      component: Recharge
    },{
      path: '/RechargeRecord',
      name: 'RechargeRecord',
      component: RechargeRecord
    },{
      path: '/MemberRechargeLog',
      name: 'MemberRechargeLog',
      component: MemberRechargeLog
    },{
      path: '/MemberOrder',
      name: 'MemberOrder',
      component: MemberOrder
    },{
      path: '/Print',
      name: 'Print',
      component: Print
    },{
      path: '/Member',
      name: 'Member',
      component: Member
    },{
      path: '/OnlineRecord',
      name: 'OnlineRecord',
      component: OnlineRecord
    },{
      path: '/AdminHome',
      name: 'AdminHome',
      component: AdminHome
    },{
      path: '/ConsumptionRecord',
      name: 'ConsumptionRecord',
      component: ConsumptionRecord
    },{
      path: '/Return',
      name: 'Return',
      component: Return
    },{
      path: '/Stock',
      name: 'Stock',
      component: Stock
    },{
      path: '/StockRecord',
      name: 'StockRecord',
      component: StockRecord
    },{
      path: '/PackageExamine',
      name: 'PackageExamine',
      component: PackageExamine
    },{
      path: '/ProductLog',
      name: 'ProductLog',
      component: ProductLog
    },{
      path: '/Promote',
      name: 'Promote',
      component: Promote
    },{
      path: '/DeOrder',
      name: 'DeOrder',
      component: DeOrder
    },{
      path: '/DeHome',
      name: 'DeHome',
      component: DeHome
    },{
      path: '/LogList',
      name: 'LogList',
      component: LogList
    },{
      path: '/DePackingStatistics',
      name: 'DePackingStatistics',
      component: DePackingStatistics
    },{
      path: '/Col',
      name: 'Col',
      component: Col
    },{
      path: '/Product',
      name: 'Product',
      component: Product
    },{
      path: '/Global',
      name: 'Global',
      component: Global
    },{
      path: '/Edit',
      name: 'Edit',
      component: Edit
    },{
      path: '/EditGlobal',
      name: 'EditGlobal',
      component: EditGlobal
    },{
      path: '/Pricing',
      name: 'Pricing',
      component: Pricing
    },{
      path: '/Bulk',
      name: 'Bulk',
      component: Bulk
    },{
      path: '/BulkGlobal',
      name: 'BulkGlobal',
      component: BulkGlobal
    },{
      path: '/Servicelimit',
      name: 'Servicelimit',
      component: Servicelimit
    },{
      path: '/Package',
      name: 'Package',
      component: Package
    },{
      path: '/PackageSet',
      name: 'PackageSet',
      component: PackageSet
    },{
      path: '/Purchased',
      name: 'Purchased',
      component: Purchased
    },{
      path: '/Shops',
      name: 'Shops',
      component: Shops
    },{
      path: '/HomePage',
      name: 'HomePage',
      component: HomePage
    },{
      path: '/Space',
      name: 'Space',
      component: Space
    },{
      path: '/ProductPromote',
      name: 'ProductPromote',
      component: ProductPromote
    },{
      path: '/RebateRecord',
      name: 'RebateRecord',
      component: RebateRecord
    },{
      path: '/BalanceManage',
      name: 'BalanceManage',
      component: BalanceManage
    },{
      path: '/OrderManage',
      name: 'OrderManage',
      component: OrderManage
    },{
      path: '/ProductManage',
      name: 'ProductManage',
      component: ProductManage
    },{
      path: '/ShopManage',
      name: 'ShopManage',
      component: ShopManage
    },{
      path: '/ManageHomePage',
      name: 'ManageHomePage',
      component: ManageHomePage
    },{
      path: '/AdminProHome',
      name: 'AdminProHome',
      component: AdminProHome
    },{
      path: '/AdminCol',
      name: 'AdminCol',
      component: AdminCol
    },{
      path: '/AdminProduct',
      name: 'AdminProduct',
      component: AdminProduct
    },{
      path: '/AdminGlobal',
      name: 'AdminGlobal',
      component: AdminGlobal
    },{
      path: '/Detail',
      name: 'Detail',
      component: Detail
    },{
      path: '/DetailGlobal',
      name: 'DetailGlobal',
      component: DetailGlobal
    },{
      path: '/PackageLog',
      name: 'PackageLog',
      component: PackageLog
    },{
      path: '/OrderStatistics',
      name: 'OrderStatistics',
      component: OrderStatistics
    },{
      path: '/AminShop',
      name: 'AminShop',
      component: AminShop
    },{
      path: '/ProductWithdraw',
      name: 'ProductWithdraw',
      component: ProductWithdraw
    },{
      path: '/PackingStatistics',
      name: 'PackingStatistics',
      component: PackingStatistics
    },{ //管理员-金融
      path: '/AdminFinHome',
      name: 'AdminFinHome',
      component: AdminFinHome
    },{
      path: '/UserList',
      name: 'UserList',
      component: UserList
    },{
      path: '/Invest',
      name: 'Invest',
      component: Invest
    },{
      path: '/FinOrder',
      name: 'FinOrder',
      component: FinOrder
    },{
      path: '/Raise',
      name: 'Raise',
      component: Raise
    },{
      path: '/Withdraw',
      name: 'Withdraw',
      component: Withdraw
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js